
const originalConsoleInfo = console.info;
console.info = (...args) => {
  if (args[0]?.includes('vue-i18n')) return;
  originalConsoleInfo(...args);
};

import { createI18n } from 'vue-i18n';


const i18n = createI18n({
    locale: 'en',
    legacy: false,
    //fallbackLocale: 'en',
    warnHtmlInMessage: 'off',
    globalInjection: true
})

export default i18n;